module.exports = __webpack_public_path__ + "static/Red_Dragon-4d2923053ed56b939e3a11744fce65fd.jpg";